import React, { useEffect } from 'react'
import { Container, Footer, Section } from 'react-bulma-components'
import { Header } from './header'
import '../../styles/main.scss'
import { translate } from '../../utils/translations'
import { useTranslations } from '../../hooks/use-translations'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { current } = useTranslations()
  useEffect(() => {
    document.title = translate('home.title')
  }, [current])
  return (
    <>
      <Section className="pt-0 mt-0">
        <Container>
          <Header />
        </Container>
      </Section>
      {children}
      <Footer backgroundColor="white" textAlign={'center'}>
        © 2022 - Fandi
      </Footer>
    </>
  )
}

export default Layout
